import React, { useCallback, useMemo, useState } from 'react';
import { Check, BarChart3, Users } from 'lucide-react';

export default function PollMessage(props) {


    const { pollData, handleUpdatePoll, message, userLength, fetchResult } = props

    const [selectedOption, setSelectedOption] = useState(null);
    const [hasVoted, setHasVoted] = useState(false);
    console.log('pollData', JSON.stringify(pollData))
    // Sample poll data
    // const [pollData, setPollData] = useState({
    //     question: "What's your favorite programming language?",
    //     options: [
    //         { id: 1, text: "JavaScript", votes: 12 },
    //         { id: 2, text: "Python", votes: 8 },
    //         { id: 3, text: "Java", votes: 5 },
    //         { id: 4, text: "TypeScript", votes: 15 }
    //     ],
    //     totalVotes: 40,
    //     timestamp: "2:30 PM"
    // });

    const handleVote = (optionId) => {
        if (hasVoted) return;

        setSelectedOption(optionId);
        setHasVoted(true);

        // Update vote counts
        // setPollData(prev => ({
        //     ...prev,
        //     options: prev.options.map(option =>
        //         option.id === optionId
        //             ? { ...option, votes: option.votes + 1 }
        //             : option
        //     ),
        //     totalVotes: prev.totalVotes + 1
        // }));
    };



    const getMaxVotes = () => {
        return Math.max(...pollData.options.map(option => option.votes));
    };
    const authUserId = localStorage.getItem("authUser");
    const uniqueVoters = new Set(
        pollData.options.flatMap(option => option.votes)
    );

    const getPercentage = (votes) => {
        console.log('votesvotes', votes, userLength)

        return userLength > 0 ? Math.round((votes / userLength) * 100) : 0;
    };

    // 
    const voteStats = useMemo(() => {
        const totalVotes = pollData.options.reduce(
            (sum, option) => sum + option.votes.length,
            0,
        );

        const userVotes = pollData.options
            .map((option, index) => ({
                index,
                hasVoted: option.votes.includes(authUserId),
            }))
            .filter(option => option.hasVoted)
            .map(option => option.index);

        return {
            totalVotes,
            userVotes,
            hasUserVoted: userVotes.length > 0,
        };
    }, [pollData.options, authUserId]);
    const getVotePercentage = useCallback(
        votes => {
            if (voteStats.totalVotes === 0) return 0;
            return Math.round((votes / voteStats.totalVotes) * 100);
        },
        [voteStats.totalVotes],
    );

    return (
        <div className="w-[450px] max-w-full mx-auto bg-white rounded-lg shadow-sm border border-primary">
            {/* Poll Message Bubble */}
            <div className=" text-black pt-6 px-4 pb-2 rounded-t-lg">
                <div className="flex items-center gap-2 mb-2">
                    <BarChart3 className="w-5 h-5 flex-shrink-0 text-primary" />
                    {/* <div className="flex-1"> */}
                    <h3 className="font-medium text-sm  text-primary">POLL</h3>

                    {/* </div> */}
                </div>
            </div>
            <div className=" text-black pb-2 px-4 rounded-t-lg">
                <p className="text-sm leading-relaxed">{pollData.question}</p>
            </div>
            {/* Poll Options */}
            <div className="px-4 space-y-3">
                {pollData.options.map((option, index) => {
                    const percentage = getVotePercentage(option.votes.length);
                    const isWinning = option.votes === getMaxVotes() && option.votes > 0;
                    const isSelected = option?.votes.includes(authUserId)
                    console.log('isSelected', isSelected, authUserId)

                    return (
                        <div
                            key={option.id}
                            onClick={() => handleUpdatePoll(message._id, index)}
                            className={`relative rounded-lg border overflow-hidden transition-all duration-200 cursor-pointer ${hasVoted
                                ? "bg-gray-50 cursor-default"
                                : "hover:bg-gray-100 active:bg-gray-100"
                                } ${isSelected ? "border-[#008293] bg-slate-200" : "border-gray-600 bg-slate-200"}`}
                        >
                            {/* Percentage Background */}
                            {option.votes.length > 0 && (
                                <div
                                    className={`absolute top-0 left-0 h-full ${isSelected ? 'bg-blue-300' : 'bg-slate-300'} transition-all duration-300`}
                                    style={{ width: `${percentage}%` }}
                                />
                            )}

                            {/* Option Content */}
                            <div className="relative z-10 p-3 flex items-center justify-between">
                                <div className="flex items-center gap-3 flex-1 min-w-0">
                                    {/* Radio Button / Check */}
                                    <div
                                        className={`w-5 h-5 rounded-full border-2  flex items-center justify-center ${isSelected
                                            ? "border-primary bg-primary"
                                            : hasVoted
                                                ? "border-gray-300"
                                                : "border-gray-400"
                                            }`}
                                    >
                                        {isSelected && <Check className="w-3 h-3 text-white" />}
                                    </div>

                                    {/* Option Text */}
                                    <p
                                        className={`text-xs font-medium leading-relaxed break-words truncate whitespace-normal ${isSelected ? "text-primary" : "text-gray-900"
                                            }`}
                                    >
                                        {option.text}
                                    </p>
                                </div>

                                {/* Vote Count and Percentage */}
                                {option.votes.length > 0 && (
                                    <div className="flex items-center gap-2 text-xs text-gray-600 flex-shrink-0">
                                        <span className="font-medium text-xs">{percentage}%</span>
                                        <span>({option.votes.length})</span>
                                    </div>
                                )}
                            </div>

                        </div>
                    );
                })}
            </div>

            {/* Poll Footer */}
            <div className="px-4 pb-4">
                <div className="flex items-center justify-between text-xs text-gray-500 mt-4">
                    <div className="flex items-center gap-1">
                        <div className="flex items-center gap-1">
                            <Users className="w-3 h-3" />
                            <span>{uniqueVoters.size} votes.</span>
                        </div>
                        {pollData.allowMultipleAnswers && <span>Multiple selection</span>}
                    </div>
                    {!hasVoted && (
                        <span onClick={(e) => {
                            e.preventDefault()
                            fetchResult(message._id)
                        }} className="text-xs text-gray-500 cursor-pointer">
                            Result
                        </span>
                    )}
                </div>


            </div>
        </div>
    );
}